import { useAuthSWR } from "hooks/utils/useAuthSWR";
import { ApiContext } from "providers/ApiProvider";
import { useContext } from "react";
import { SWRResponse } from "swr";

export const SWR_DEPOSIT_ADDRESS_PAID_STATUS_KEY =
  "get-deposit-address-paid-status";

export const useGetDepositAddressPaidStatus = (
  currencyId?: string,
  payment_network?: string,
): SWRResponse<void> => {
  const { memberInstance } = useContext(ApiContext);
  const swr = useAuthSWR(
    currencyId && payment_network
      ? [SWR_DEPOSIT_ADDRESS_PAID_STATUS_KEY, currencyId, payment_network]
      : null,
    async () => {
      if (!currencyId || !payment_network) {
        return;
      }
      await memberInstance.payments.getMemberDepositAddressPaidStatus({
        currency_id: currencyId,
        payment_network_id: payment_network,
      });
      return;
    },
    {
      revalidateIfStale: false,
      errorRetryInterval: 2000,
    },
  );
  return swr;
};
